// src/pages/ContactPage.js
import React from "react";
import { Contact } from "../components/contact";

export const ContactPage = ({ data }) => {
  return (
    <div className="standalone-page">
      <Contact data={data} />
    </div>
  );
};